import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Panel from '../../../../UniformComponents/Panel'
import Select from '../../../form/Select'
import QuestionImportExportStore from './store'

import './style.scss'
import Button from '../../../../UniformComponents/Button'
import AppLoading from '../../../AppLoading'

@observer
class QuestionImportExport extends Component {
    constructor(props) {
        super(props)

        const { store } = props
        this.questionImportExportStore = new QuestionImportExportStore(store)
    }

    componentDidMount() {
        const { store } = this.props
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'questionImpEx',
                url: '/intranet/questionImpEx',
                title: 'Question Import/Export Tool',
            },
        ]

        this.questionImportExportStore.init()
    }

    renderInfo = () => {
        const { questionImportExportStore } = this
        const { details } = questionImportExportStore
        const { type, msg, url } = details

        if (R.isEmpty(type)) return null

        return (
            <div className={`info ${type}`}>
                {!R.isEmpty(msg) && <span>{msg}</span>}
                {!R.isEmpty(url) && <a href={url} target="_blank" rel="noreferrer">File Download</a>}
            </div>
        )
    }

    render() {
        const { questionImportExportStore } = this
        const {
            clients,
            changeClient,
            selectedClient,
            isLoading,
            downloadQuestions,
            changeUploadFile,
            uploadQuestions,
            file,
        } = questionImportExportStore

        return (
            <Fragment>
                <AppLoading hide={!isLoading} />
                <Panel cssClass="questionImpEx">
                    {this.renderInfo()}
                    <div>
                        <Select
                            options={clients}
                            value={selectedClient}
                            onBlur={changeClient}
                        />
                    </div>
                    <div>
                        <Button
                            label="Download Questions as Comma delimited CSV"
                            onClick={downloadQuestions}
                            cssClass="regular primary"
                        />
                    </div>
                    <div className="questionImport">

                        <input
                            type="file"
                            ref={(input) => { questionImportExportStore.fileInput = input }}
                            onChange={changeUploadFile}
                        />
                        <div className="file">
                            <Button
                                label="Choose File"
                                onClick={() => { questionImportExportStore.fileInput.click() }}
                                cssClass="regular tertiary"
                            />
                            {!R.isNil(file) && (
                                <span>{file.name}</span>
                            )}
                        </div>
                        <Button
                            label="Upload Questions as Comma delimited CSV"
                            onClick={uploadQuestions}
                            cssClass="regular primary"
                        />
                    </div>
                </Panel>
            </Fragment>
        )
    }
}

export default QuestionImportExport
